module.exports = __webpack_public_path__ + "img/zongbu.e93e3c51.png";